import { asyncAction } from '@play-co/replicant';
import {
  getExpiredMarketingIds,
  getMarketingEventById,
  getMarketingRewards,
  isMarketingEventConsumed,
  isMarketingEventFinished,
} from './marketing.getters';
import createActions from '../config/actions/createActions';
import { setServerMarketingEvents } from '../ruleset/airtable';
import * as Inventory from '../inventory';
import { Feature } from '../analytics';

export default createActions({
  /**
   * Consume reward from social pages
   */
  consumeMarketingReward: asyncAction(
    async (state, args: { eventId: string }, api) => {
      try {
        setServerMarketingEvents(await api.asyncGetters.fetchMarketingEvents());
      } catch (e) {
        console.error('Could not fetch marketing events.', e);
      }

      // Get event config
      const event = getMarketingEventById(args.eventId);
      const now = api.date.now();

      // Check if config exist
      if (!event) {
        throw new Error(
          `Can't consume marketing reward, not config for event: ${args.eventId}`,
        );
      }

      // Check if this reward is not consumed
      if (isMarketingEventConsumed(state, event.id)) {
        throw new Error(
          `Can't consume marketing reward, event: ${event.id} already consumed`,
        );
      }

      // Check if event is finished
      if (isMarketingEventFinished(event.id, now)) {
        throw new Error(
          `Can't consume marketing reward, event: ${event.id} is finished`,
        );
      }

      const rewards = getMarketingRewards(event);

      if (rewards.coins) {
        Inventory.modifiers.addPoints(
          state,
          rewards.coins,
          {
            feature: Feature.MARKETING._,
            $subFeature: event.id,
          },
          api,
        );
      }

      if (rewards.gems) {
        Inventory.modifiers.addFreeGems(
          state,
          rewards.gems,
          {
            feature: Feature.MARKETING._,
            $subFeature: event.id,
          },
          api,
        );
      }

      // Save given reward to state
      state.marketing[event.id] = now;

      const ids = getExpiredMarketingIds(state, now);

      for (const id of ids) {
        delete state.marketing[id];
      }
    },
  ),
});
